import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const GET_VENUE_FOR_EDIT_FAIL = "GET_VENUE_FOR_EDIT_FAIL";

export interface GetVenueForEditFailAction extends Action {
  type: typeof GET_VENUE_FOR_EDIT_FAIL;
  organization: OrganizationKeyName;
}

export const getVenueForEditFailAction = (
  organization: OrganizationKeyName
): GetVenueForEditFailAction => ({
  type: GET_VENUE_FOR_EDIT_FAIL,
  organization,
});
